import { render } from "./UsageRecords.vue?vue&type=template&id=738128e3&scoped=true"
import script from "./UsageRecords.vue?vue&type=script&lang=js"
export * from "./UsageRecords.vue?vue&type=script&lang=js"

import "./UsageRecords.vue?vue&type=style&index=0&id=738128e3&lang=less&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-738128e3"]])

export default __exports__